import { Dialog } from '@headlessui/react';
import { AnimatePresence, motion } from 'motion/react';
import { FC } from 'react';
import LightboxContent, {
  TProps as TLightboxContentProps,
} from './LightBoxContent';
import LightBoxImage from './LightBoxImage';
import LightboxPdf from './LightboxPDF';
import LightboxVideo from './LightboxVideo';

export type TProps = {
  isOpen: boolean;
} & TLightboxContentProps;

const Lightbox: FC<TProps> = (props) => {
  const { isOpen, onClose, onNext, onPrev, lightboxDetail } = props;

  return (
    <AnimatePresence>
      {isOpen && (
        <Dialog static open={isOpen} onClose={onClose}>
          {/* backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/80 z-lightbox-backdrop"
          />

          <LightboxContent
            onClose={onClose}
            onNext={onNext}
            onPrev={onPrev}
            lightboxDetail={lightboxDetail}
          />
        </Dialog>
      )}
    </AnimatePresence>
  );
};

export default Object.assign(Lightbox, {
  Image: LightBoxImage,
  PDF: LightboxPdf,
  Video: LightboxVideo,
});
